import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ImagePreview = memo(({ src, alt, rotation }) => {
  const deg = rotation || 0;

  return (
    <div className={`u_fv-preview-image-wrap${Math.abs(deg % 180) === 90 ? ' u_img-sideways' : ''}`}>
      <img
        className="u_fv-preview-image"
        style={{ transform: `rotate(${deg}deg)` }}
        src={src}
        alt={alt || "File Preview"}
      />
    </div>
  );
});

ImagePreview.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  rotation: PropTypes.number,
};

export default ImagePreview;